export interface IOperationsDetails {
  officerName: string;
  rank: string | null;
  badge: string | null;
  totalCitationsCount: number;
  totalWarningsCount: number;
  lastLoginDateTime: string | null;
  lastSubmitDateTime: string | null;
  lastCitationDateTime: string | null;
  lastWarningDateTime: string | null;
  last7DaysCitationsCount: number;
  last7DaysWarningsCount: number;
  last30DaysCitationsCount: number;
  last30DaysWarningsCount: number;
}

export interface IReportDetailsResponse extends IOperationsDetails {
  topNames: [
    {
      count: number;
      title: string;
    },
  ];
  topGenders: [
    {
      count: number;
      title: string;
    },
  ];
  topRaces: [
    {
      count: number;
      title: string;
    },
  ];
  lastLocations: [
    {
      id: number;
      longitude: number;
      latitude: number;
    },
  ];
}

export interface TitledCount {
  title: string;
  count: number;
}

export interface TitleDetails {
  title: string;
  text: string | number;
}

export enum DetailTitleCells {
  OFFICER_NAME = 'Officer Name',
  RANK = 'Rank',
  BADGE = 'Badge',
  TOTAL_CITATIONS_COUNT = 'Total Citations',
  TOTAL_WARNINGS_COUNT = 'Total Warnings',
  LAST_LOGIN_DT = 'Last Login DT',
  LAST_CITATION_DT = 'Last Citation DT',
  LAST_WARNING_DT = 'Last Warning DT',
  LAST_7_DAYS_CITATIONS = 'Last 7 Days Citations',
  LAST_30_DAYS_CITATIONS = 'Last 30 Days Citations',
  LAST_7_DAYS_WARNINGS = 'Last 7 Days Warnings',
  LAST_30_DAYS_WARNINGS = 'Last 30 Days Warnings',
}
